export default {
    // 西班牙语
    LOCALE_HTML: {
        'msg.language': '西班牙语',
        'msg.title': 'Título',
        'msg.type': 'Categoría de pregunta',
        'msg.des': 'Descripción de pregunta',
        'msg.phone': 'Número de teléfono',
        'msg.regionCode': 'Codigo de AREA',
        'msg.email': 'Dirección de correo electrónico',
        'msg.choose': 'Seleccione una categoría',
        'msg.detail': 'Detalles del mensaje',
        'msg.back': 'vuelva',
        'your.msg': 'Deje su mensaje',
        'msg.record': 'Registro de mensajes',
        'msg.success': 'Mensaje exitoso',
        'to.record': 'Ir al registro de mensajes',
        completed: 'Completo',
        submit: 'Enviar',
        'success.desc': 'Su mensaje ha sido enviado con éxito, gracias',
        'msg.form.input': 'Escriba',
        'msg.reply': 'Respuesta',
        'comment.suc': '¡Gracias por tu reseña!',
        'comment.fail': 'Envío fallido',
        'comment.placeholder':
            'Le invitamos a dar sugerencias sobre nuestros servicios.',
        'reply.suc': '¡Enviado con éxito!',
        'reply.fail': 'Por favor ingrese su respuesta',
        'reply.placeholder': 'Por favor ingrese su respuesta',
        'msg.more': 'Ver más',
        'msg.collapse': 'Guardar',
        'msg.myservice': 'Mi evaluación de servicio',
        'msg.evaluate': 'Calificación de servicio',
        'msg.evaluateTitle': 'Calificación de servicio',
        'msg.score': 'Puntaje:',
        'msg.remark': 'Comentarios:',
        'msg.status.created': 'Creado',
        'msg.status.pending': 'Pendiente',
        'msg.status.processing': 'Realizando',
        'msg.status.solved': 'Terminado',
        'msg.service.reply': 'Respuesta de servicio al cliente',
        'msg.my.reply': 'Su Respuesta.',
        'msg.toast.des': 'La descripción del problema está vacía',
        'msg.toast.type': 'La descripción del problema está vacía',
        'msg.toast.title': 'El título está vacío',
        'msg.toast.none': 'No puede estar vacío',
        'msg.toast.noAnnex': 'Por favor suba archivos adjuntos',
        'msg.toast.noEmail': 'El correo electrónico no puede estar vacío',
        'msg.toast.noTel': 'El número de teléfono no puede estar vacío',
        'msg.toast.noRegionCode': 'El código de área no puede estar vacío.',
        'msg.toast.noZone': 'Por favor seleccione una zona horaria',
        'msg.toast.noDateTime': 'Por favor seleccione fecha hora',
        'msg.toast.email': 'Por favor ingrese su correo electrónico válido',
        'msg.toast.tel': 'Por favor ingrese un número de teléfono válido',
        'msg.toast.regionCode': 'Por favor seleccione el código de área',
        'msg.toast.num': 'Por favor ingrese el número correcto',
        'msg.toast.annex': 'Por favor suba archivos adjuntos',
        'msg.toast.char': 'Por favor ingrese los caracteres correctos',
        'msg.list.none': 'Sin datos',
        'msg.form.choose': 'Elija',
        'msg.form.chooseZone': 'Selecciona la zona horaria',
        'msg.form.chooseTime': 'Seleccionar hora',
        'msg.form.chooseDate': 'Seleccionar fecha',
        'msg.form.sure': 'Sí',
        'msg.form.search': 'Buscar...',
        'msg.form.uploadError': 'Formato erróneo',
        'msg.form.uploadXss':
            'La carga falló, el contenido del archivo contiene una secuencia de comandos ilegal',
        'msg.update.time': 'actualizado en',
        'msg.replace.images': 'imagen',

        MSG016: 'resuelto',
        MSG017: 'no resuelto',
        MSG019: 'entregar',
        MSG072: '¡La etiqueta de evaluación no puede estar vacía! ',
        MSG073: '¡El lenguaje de evaluación no puede estar vacío! ',
        MSG074: 'Etiqueta:',
        MSG075: '¿Está resuelto:',
        MSG076: 'Por favor seleccione si el problema está resuelto.',
        MSG015: '¿Este ticket resolvió su problema?',

        'file.size.limit': 'El tamaño del archivo no puede exceder los 50 MB',
        'detail.file.limit': '15 como máximo, el tamaño no supera los 50 M',
        'form.question.des.tip': 'Ingrese una descripción del problema',
        'form.title.tip': 'Por favor ingrese un titulo',
        'form.class.tip': 'Seleccione la categoría del problema',
        'upload.file': 'Subir archivo adjunto',
        'file.count.limit': 'Solo puede cargar hasta 15 archivos adjuntos',
        'select.search.placeholder': 'Buscar la palabra clave',
        'msg.form.sizeError1': 'Sube archivos adjuntos de menos de 5 M',
        'msg.form.sizeError2': 'Sube archivos adjuntos de menos de 50 M',
        'msg.form.submit': 'Sumisión...',
        'msg.form.upload': 'Subiendo ...',
        'msg.email.tip1': 'No se encontró su mensaje',
        'msg.email.tip2':
            'Si ha dejado un mensaje antes, puede verificarlo mediante verificación por correo electrónico',
        'msg.email.tip3': 'Iniciar la verificación por correo electrónico',
        'msg.email.noData': 'No hay datos en la cuenta corriente',
        'email.verify.tip':
            'Ingrese la dirección de correo electrónico utilizada al dejar un mensaje',
        'email.input.placeholder': 'Ingrese la dirección de correo electrónico',
        'email.submit': 'Enviar correo electrónico',
        'email.rules.error': 'Por favor ingrese su correo electrónico válido',
        'email.code.tip':
            'El correo electrónico ha sido enviado, ingrese el código de verificación que recibió.',
        'email.code.placeholder': 'pPr favor ingrese el código de verificación',
        'email.code.submit': 'Ver ahora',
        'email.notFind.customer': 'No se encontró la información del cliente',
        'email.code.wrong':
            'El código de verificación es incorrecto, vuelva a ingresar',
        'email.code.expired':
            'El código de verificación ha caducado, vuelva a verificar el correo electrónico.',
        'email.code': 'Código de verificación',
        'email.send.frequently':
            'La operación es demasiado frecuente, inténtelo de nuevo más tarde.',
        'comment.fail.400133': 'Este boleto ha sido calificado',
        'not.get.user.info': 'No se puede obtener su información',
        'user.verify.tip':
            'Necesita pasar la verificación antes de ver el contenido de la lista de mensajes',
        'verify.type.email': 'Verificación del buzón',
        'verify.text': 'Verificación',
        'cancel.text': 'Cancelación',
        'get.verify.code': 'Obtener el Código de verificación',
        'reGet.verify.code': 'Recuperar ',
        'verify.by.email.tip':
            'El Código de verificación se enviará por correo electrónico a la cuenta de correo electrónico que ingresó.',
        'verify.type.phone': 'Verificación por SMS',
        'phone.placeholder':
            'Por favor, introduzca el número de teléfono móvil',
        'verify.by.phone.tip':
            'El Código de verificación se enviará a través de un mensaje de texto al número de teléfono móvil que ingresó.',
        'phone.error': 'Introduzca el número de teléfono correcto',
        'phone.errorCode400150':
            'Los códigos de verificación se envían con frecuencia',
        'phone.errorCode400233': 'La plantilla de SMS no puede estar vacía',
        'phone.errorCode400234':
            'El saldo de los mensajes de texto de Marketing es insuficiente',
        'phone.errorCode400235':
            'Saldo insuficiente de los mensajes de texto de notificación',
        'phone.errorCode400247':
            'Configuración incorrecta del mensaje de texto del plug - in de la orden de trabajo',
        'phone.errorCode4400248': 'Falló la obtención de la plantilla de SMS',
        'phone.errorCode400249':
            'Este número no es el número de teléfono móvil del usuario existente.',
        'phone.errorCode400250':
            'El Código de verificación ha expirado, por favor vuelva a obtenerlo',
        'msg.you.reply': 'Respuesta a usted.',
        'msg.no.reply':'ninguna respuesta',
    },
    LOCALE_REQUEST: {
        400016: 'La obtención de información de la orden de trabajo ha caducado, ¡actualice!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'borrar',
                cancel: 'Cancelar',
                confirm: 'Seguro',
                inert: 'insertar',
                width: 'ancho',
                height: 'alto'
            },
            controls: {
                clear: 'contenido claro',
                undo: 'revocar',
                redo: 'rehacer',
                fontSize: 'tamaño de fuente',
                lineHeight: 'altura de la línea',
                letterSpacing: 'espacio entre palabras',
                textIndent: 'sangría de párrafo',
                increaseIndent: 'aumentar la sangría',
                decreaseIndent: 'reducir la sangría',
                border: 'marco',
                color: 'color',
                textColor: 'color de texto',
                backgroundColor: 'color de fondo',
                tempColors: 'color temporal',
                bold: 'atrevido',
                italic: 'cursiva',
                underline: 'subrayar',
                strikeThrough: 'tachado',
                fontFamily: 'fuente',
                textAlign: 'alineación del texto',
                alignLeft: 'izquierda',
                alignCenter: 'en el centro',
                alignRight: 'Bien',
                alignJustify: 'ambos extremos',
                floatLeft: 'flotador izquierdo',
                floatRight: 'flotar derecho',
                superScript: 'Sobrescrito',
                subScript: 'subíndice',
                removeStyles: 'estilo claro',
                headings: 'título',
                header: 'título',
                normal: 'convencional',
                orderedList: 'lista ordenada',
                unorderedList: 'lista desordenada',
                blockQuote: 'cita',
                code: 'el código',
                link: 'Enlace',
                unlink: 'enlace claro',
                hr: 'linea horizontal',
                media: 'medios de comunicación',
                mediaLibirary: 'Mediateca',
                emoji: 'pequeña expresión',
                fullscreen: 'pantalla completa',
                exitFullscreen: 'Salir de pantalla completa'
            },
            linkEditor: {
                textInputPlaceHolder: 'ingrese el texto del enlace',
                linkInputPlaceHolder: 'Introduzca la dirección del enlace',
                inputWithEnterPlaceHolder:
                    'Ingrese la dirección del enlace y presione Entrar',
                openInNewWindow: 'abrir en Nueva ventana',
                removeLink: 'remover enlace'
            },
            audioPlayer: {
                title: 'reproducir archivo de audio'
            },
            videoPlayer: {
                title: 'reproducir archivo de vídeo',
                embedTitle: 'medios incrustados'
            },
            media: {
                image: 'imagen',
                video: 'video',
                audio: 'audio',
                embed: 'medios incrustados'
            }
        },
        finder: {
            remove: 'borrar',
            cancel: 'Cancelar',
            confirm: 'confirmar',
            insert: 'insertar elemento seleccionado',
            width: 'ancho',
            height: 'alto',
            image: 'imagen',
            video: 'video',
            audio: 'audio',
            embed: 'medios incrustados',
            caption: 'Mediateca',
            dragTip: 'Haga clic o arrastre el archivo aquí',
            dropTip: 'Liberar para cargar',
            selectAll: 'seleccionar todo',
            deselect: 'cancelar selección',
            removeSelected: 'eliminar elemento seleccionado',
            externalInputPlaceHolder: `Nombre del recurso|Dirección del recurso`,
            externalInputTip: `Use "|" para separar el nombre del recurso y la dirección del recurso`,
            addLocalFile: 'Agregar recursos locales',
            addExternalSource: 'Agregar recurso web',
            unnamedItem: 'proyecto sin titulo',
            confirmInsert: 'Insertar elemento seleccionado'
        }
    }
}
